// utils modules
import axios from 'axios';

import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';

export const getSubDomain = () => {
  const { hostname } = window.location;
  const regexParse = new RegExp('[a-z-0-9]{2,63}.[a-z.]{2,5}$');
  const urlParts = regexParse.exec(hostname);
  return hostname.replace(urlParts[0], '').slice(0, -1);
};

export const getToken = () => localStorage.getItem('token');
export const isUserAuthenticated = () => {
  if (getSubDomain() === touristEntryPoint) {
    // if on tour.domain.com treat user as non-authenticated and use local cart
    return false;
  }
  return getToken() !== null;
};
export const removeToken = () => localStorage.removeItem('token');

function cleanForLanguage(dirtyProduct) {
  const product = { ...dirtyProduct };
  const temp = product.name;
  product.name = product.description;
  product.description = temp;
  return product;
}

export const getLocalCart = (callback = () => {}) => {
  let cartProductsList = JSON.parse(localStorage.getItem('cart')) || [];
  if (getLanguage() !== 'en') {
    cartProductsList = cartProductsList.map(product => cleanForLanguage(product));
  }
  callback(cartProductsList);
};

export const clearLocalCart = (callback = () => {}) => {
  const emptyCartList = [];
  setLocalCart(emptyCartList, callback);
};

/*
  cleanObject
    takes in an object and returns a new object based on the desiredShape
  parameters:
    obj: object to clean
    desiredShape: transformation object:
      ex)
      {
        id: 'SalesOrder_id', // this will have the value of obj.SalesOrder_id
        nestedExample: 'cars.honda.accord',
        fullName: obj => `${obj.FirstName} ${obj.LastName}`,
        products: obj => obj.Product_Line_List.map(product => {name: product.Name})
      }
  returns:
    new object with transformed shape or original shape if desiredShape is an empty object
*/
export const cleanObject = (obj, desiredShape) => {
  if (isEmpty(desiredShape)) {
    return obj;
  }
  return transform(obj, desiredShape);
};

// initial state
const state = {
}

// actions
const actions = {
};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/utils.js